import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';

import { EProductSizes } from '../../../model/enums';
import miniAccessoryImg from '../../../assets/images/products/accessories/plastic-tray-mini-base.jpg';
import standardAccessoryImg from '../../../assets/images/products/accessories/plastic-tray-standard-base.jpg';
import { $productsState } from '../../../store/models/products';
import advantagesSVG from '../../../assets/images/icons/advantage.svg';
import { $cartState, handleToggleAccessory } from '../../../store/models/cart';

import styles from './styles.module.scss';

const AccessoryCart = () => {
  const { t } = useTranslation();
  const { isSelectedAccessory, selectedProductSize } = useUnit($cartState);
  const { accessories } = useUnit($productsState);
  const selectedAccessory = accessories.find(ac => ac.size === selectedProductSize);
  const accessoryImg =
    selectedProductSize === EProductSizes.mini
      ? miniAccessoryImg
      : standardAccessoryImg;

  function handleSelect() {
    handleToggleAccessory();
  }

  // No tray sold for the picked size (or no size picked yet) — don't offer one.
  if (!selectedAccessory) {
    return null;
  }

  return (
    <label className={`${styles.accessoryCart} ${isSelectedAccessory && styles.selectedRadioItem}`} >
      <input
        type="checkbox"
        className={styles.accessoryCheckbox}
        checked={isSelectedAccessory}
        onChange={handleSelect}
      />
      <div className={styles.accessoryCart_headline}>
        <p>{t('protectsYourGrass')}</p>
      </div>
      <div className={styles.content}>
        <h3>{t('plasticTray')}</h3>
        <div className={styles.price}>€{selectedAccessory?.price}</div>
        <p>{t('easyPottyTraining')}</p>
        <div className={styles.advantages}>
          <div className={styles.advantages_item}>
            <img src={advantagesSVG} alt="Advantages" />{' '}
            <p>{t('fitYourChosenBox')}</p>
          </div>
        </div>
        <div className={styles.accessory_imgWrapper}>
          <img src={accessoryImg} alt="Accessory" />
        </div>
      </div>
    </label>
  );
};

export default AccessoryCart;
